import React from 'react';
import StatCard from '../common/StatCard';
import { CreditCard, Users, ShoppingCart, Bot, Repeat } from 'lucide-react';

const formatInt = (value) => Number(value || 0).toLocaleString('ru-RU');
const formatMoney = (value) =>
    Number(value || 0).toLocaleString('ru-RU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

const StatsOverview = ({ stats, periodLabel = '30 дн.' }) => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
            <StatCard
                title={`Выручка за ${periodLabel} (₽)`}
                value={formatMoney(stats.revenue)}
                icon={CreditCard}
                colorClass="bg-indigo-600"
            />
            <StatCard
                title={`Пользователи за ${periodLabel}`}
                value={formatInt(stats.users)}
                icon={Users}
                colorClass="bg-blue-500"
            />
            <StatCard
                title={`Заказы за ${periodLabel}`}
                value={formatInt(stats.orders)}
                icon={ShoppingCart}
                colorClass="bg-purple-500"
            />
            <StatCard
                title={`Оборот реф. ботов за ${periodLabel} (₽)`}
                value={formatMoney(stats.referral_turnover)}
                icon={Bot}
                colorClass="bg-emerald-600"
            />
            <StatCard
                title={`Клиентов обменяло за ${periodLabel}`}
                value={formatInt(stats.referral_clients_count)}
                icon={Repeat}
                colorClass="bg-amber-500"
            />
        </div>
    );
};

export default StatsOverview;
